import { StringService } from '../../services';

export interface AssetData {
  id: string;
  filename: string;
  title: string;
  copyright: string;
  focus: string;
  alt: string;
  name: string;
  fieldtype?: string;
}

export const maskAssetUrl = (url: string): string => url.replace('a.storyblok.com', process.env.GATSBY_ROCHE_ASSET_URL_MASK);

const convertToStoryblokImageService = (url: string): string => `${url}/m/$0x/filters:format(webp)/`;

export const parseAssetSource = (filename: string, key?: string): string => {
  if (typeof filename !== 'string' || StringService.isVideoUrl(filename)) {
    return filename;
  }

  // convertToStoryblokImageService is handled only in roche-image component
  return StringService.isImageUrl(filename) && key === 'src'
    ? convertToStoryblokImageService(filename)
    : maskAssetUrl(filename);
};

export const asset = (key: string, data: AssetData): Record<string, string> => ({
  [key]: JSON.stringify({
    src: parseAssetSource(data.filename, key),
    caption: data.title,
    copyright: data.copyright,
    alt: data.alt,
  }),
});

export const parseDownloadSource = (filename: string): string => {
  if (typeof filename !== 'string' || StringService.isVideoUrl(filename)) {
    return filename;
  }

  return maskAssetUrl(filename);
};
